import React from 'react';
import ReactDatetime from "react-datetime";
import moment from "moment/moment";

export const DatePickerFilter = (props) => {

    const formatDateDe = (moment) => {
        return moment.local().format('DD.MM.YYYY HH:mm');
    };

    const onChange = (newDate) => {
        if(!(newDate instanceof moment)) {
            return;
        }

        props.onChange(newDate);
    };

    return(
        <ReactDatetime locale="de"
                       value={formatDateDe(
                           props.date)}
                       dateFormat={'DD.MM.YYYY'}
                       timeFormat={'HH:mm'}
                       onChange={onChange}/>
    )

};

export default DatePickerFilter;


// WEBPACK FOOTER //
// ./src/admin/replenishment/DatePickerFilter.js